// ---------------------------------------------------------
// Determine Redirect URI
// ---------------------------------------------------------

const getRedirectUri = () => {

  // Local development
  if (window.location.hostname.toLowerCase() === "localhost") {
    return "http://localhost:3000";
  }

  // DEV:
  // https://dev.hgeo.doe.gov/internal-forms/
  //
  // PROD:
  // https://portal.hgeo.doe.gov/internal-forms/
  //
  // No hostname needs to be hardcoded.
  return `${window.location.origin}/internal-forms/`;
};


// ---------------------------------------------------------
// MSAL Configuration
// ---------------------------------------------------------

export const msalConfig = {

  auth: {

    clientId:
      "865b1585-50a0-47d0-be67-281a84d6c58c",

    authority:
      "https://login.microsoftonline.com/6b183ecc-4b55-4ed5-b3f8-7f64be1c4138",

    redirectUri: getRedirectUri(),

    // Return to the URL that initiated authentication
    navigateToLoginRequestUrl: true
  },


  cache: {

    // Keep authentication for the current browser tab/session
    cacheLocation: "sessionStorage",

    storeAuthStateInCookie: false
  }

};


// ---------------------------------------------------------
// Login Request
// ---------------------------------------------------------

export const loginRequest = {

  scopes: [
    "openid",
    "profile",
    "email"
  ]

};